<template>
<div>
    <!-- modal -->
    <b-modal id="clientAccountingFormModal" centered size="lg" no-close-on-backdrop ref="clientAccountingFormModal" :title="$t('clientAccounting.info')" :cancel-title="$t('others.cancel_title')" :ok-title="$t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate" @close="clear()">
        <validation-observer ref="simpleRules">
            <b-row>
                <b-col class="col-md-3 mt-2">
                    <div>
                        <label for="account_number-input">
                            {{ $t('clientAccounting.used_for_invoice') }}
                        </label>
                        <b-form-checkbox :checked="invoiceChecked" class="custom-control-success" name="check-button" v-model="invoiceChecked" @change="onInvoiceCheckedChange()" switch>
                            <span class="switch-icon-left">
                                <feather-icon icon="CheckIcon" />
                            </span>
                            <span class="switch-icon-right">
                                <feather-icon icon="XIcon" />
                            </span>
                        </b-form-checkbox>
                    </div>
                </b-col>
                <b-col class="col-md-3 mt-2">
                    <label for="account-id-number-input">{{ $t('clientAccounting.accounting_id') }}</label>
                    <b-form-input :disabled="!invoiceChecked" id="account-id-number-input" v-model="accountIdNumber" maxlength="10" readonly />
                </b-col>
                <b-col class="col-md-3 mt-2">
                    <label for="client-accounting-foreign-currency">{{ $t('clientAccounting.foreign_currency') }}</label>
                    <b-form>
                        <validation-provider :name="$t('clientAccounting.foreign_currency')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <b-form-select :disabled="!invoiceChecked" :state="errors.length > 0 ? false : null" v-model="foreignCurrencySelect" value-field="id" text-field="name" :options="foreignCurrencyOption" />
                            <small class="text-danger">{{ errors[0] }}</small>

                        </validation-provider>
                    </b-form>
                </b-col>
                <b-col class="col-md-3 mt-2">
                    <label for="jurisdiction-input">{{ $t('clientAccounting.jurisdiction') }}</label>
                    <b-form>
                        <validation-provider :name="$t('clientAccounting.jurisdiction')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <b-form-select :disabled="!invoiceChecked" :state="errors.length > 0 ? false : null" v-model="jurisdictionSelect" value-field="id" text-field="name" :options="jurisdictionOption" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col class="col-md-4 mt-2">
                    <b-form>
                        <label for="tax-no-input">{{ $t('client.tax_no') }}</label>
                        <b-form-group>
                            <b-form-input :disabled="!invoiceChecked" id="tax-no-input" v-model="taxNo" maxlength="150" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-md-4 mt-2">
                    <b-form>
                        <label for="client-accounting-invoice-currency">{{ $t('clientAccounting.invoice_currency') }}</label>
                        <b-form-select :disabled="!invoiceChecked" v-model="invoiceCurrencySelect" value-field="id" text-field="name" :options="foreignCurrencyOption" />
                    </b-form>
                </b-col>
                <b-col class="col-md-4 mt-2">
                    <b-form>
                        <label for="invoice-send-type-input">{{ $t('client.invoice_send_type') }}</label>
                        <b-form-select :disabled="!invoiceChecked" v-model="invoiceSendTypeSelect" value-field="id" text-field="name" :options="invoiceSendTypeOption" />
                    </b-form>
                </b-col>
            </b-row>

            <b-row class="mt-2">
                <b-col class="col-md-4 mt-2">
                    <div>
                        <label for="account_number-input">
                            {{ $t('clientAccounting.is_agent') }}
                        </label>
                        <b-form-checkbox v-model="agentChecked" :disabled="!invoiceChecked" class="custom-control-success" name="check-button" switch>
                            <span class="switch-icon-left">
                                <feather-icon icon="CheckIcon" />
                            </span>
                            <span class="switch-icon-right">
                                <feather-icon icon="XIcon" />
                            </span>
                        </b-form-checkbox>
                    </div>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col class="col-lg-4 mt-2">
                    <b-form>
                        <label for="client-accounting-price-list">{{ $t('clientAccounting.price_list') }}</label>
                        <b-form-select :disabled="!invoiceChecked" v-model="priceListSelect" value-field="id" text-field="name" :options="priceListOption" />
                    </b-form>
                </b-col>
                <b-col class="col-lg-4 mt-2">
                    <label for="discount-input">{{ $t('clientAccounting.discount') }}</label>
                    <b-form-group>
                        <validation-provider #default="{ errors }" :name="$t('clientAccounting.discount')" rules="between:0,100">
                            <b-form-input :disabled="!invoiceChecked" id="discount-input" type="number" v-model="discount" maxlength="10" :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
                <b-col class="col-md-2 mt-2">
                    <label for="client-accounting-invoice-alert-day-select">{{ $t('clientAccounting.invoice_alert_day') }}</label>
                    <b-form>
                        <validation-provider :name="$t('clientAccounting.invoice_alert_day')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <b-form-select :disabled="!invoiceChecked" :state="errors.length > 0 ? false : null" v-model="invoiceAlertDaySelect" value-field="id" text-field="name" :options="invoiceAlertDayOption" :change="onInvoiceAlertDaySelectChange()" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form>
                </b-col>
                <b-col class="col-lg-2 mt-2">
                    <label for="invoice-alert-day-input">{{ $t('clientAccounting.invoice_alert_day') }}</label>
                    <b-form-group>
                        <validation-provider #default="{ errors }" :name="$t('clientAccounting.invoice_alert_day')" rules="between:0,9999">
                            <b-form-input :disabled="!invoiceChecked || invoiceAlertDaySelect != 4" id="invoice-alert-day-input" type="number" v-model="invoiceAlertDay" maxlength="10" :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col class="col-lg-4 mt-2">
                    <b-form>
                        <label for="note-to-be-on-invoice-input">{{ $t('clientAccounting.note_to_be_on_invoice') }}</label>
                        <b-form-select :disabled="!invoiceChecked" v-model="noteToBeOnInvoiceSelect" value-field="id" text-field="code" :options="noteToBeOnInvoiceOption" />
                    </b-form>
                </b-col>
                <b-col class="col-lg-4 mt-2">
                    <b-form>
                        <b-form-group :label="$t('clientAccounting.accounting_category')" label-for="accountingCategory">
                            <b-form-select :disabled="!invoiceChecked" id="accountingCategory" v-model="accountingCategorySelect" :options="accountingCategoryOption" text-field="name" value-field="id">
                            </b-form-select>
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-md-4 mt-2" v-if="invoiceSendTypeSelect == 1">
                    <validation-provider #default="{ errors }" :name=" $t('clientAccounting.invoice_special_email_address')" rules="required">
                        <label for="invoice-special-email-input">{{ $t('clientAccounting.invoice_special_email_address') }}</label>
                        <b-form-group>
                            <b-form-input id="invoice-special-email-input" v-model="invoiceSpecialEMailAddressToSend" maxlength="50" :state="errors.length > 0 ? false:null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-md-4 mt-2">
                    <label for="client-accounting-invoice-send-format">{{ $t('clientAccounting.invoice_send_format') }}</label>
                    <b-form>
                        <validation-provider :name="$t('clientAccounting.invoice_send_format')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <b-form-select :disabled="!invoiceChecked" :state="errors.length > 0 ? false : null" v-model="invoiceSendFormatSelect" value-field="id" text-field="name" :options="invoiceSendFormatOption" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form>
                </b-col>
                <b-col class="col-md-4 mt-2">
                    <label for="client-accounting-invoice-send-period">{{ $t('clientAccounting.invoice_send_period') }}</label>
                    <b-form>
                        <validation-provider :name="$t('clientAccounting.invoice_send_period')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <b-form-select :disabled="!invoiceChecked" :state="errors.length > 0 ? false : null" v-model="invoiceSendPeriodSelect" value-field="id" text-field="name" :options="invoiceSendPeriodOption" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form>
                </b-col>
            </b-row>
            <b-row class="mt-2" v-if="invoiceSendTypeSelect == 2">
                <b-col class="col-md-4 mt-2">
                    <label for="client-accounting-e-billing-portal">{{ $t('clientAccounting.e_billing_portal') }}</label>
                    <b-form>
                        <validation-provider :name="$t('clientAccounting.e_billing_portal')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <b-form-select :disabled="!invoiceChecked" :state="errors.length > 0 ? false : null" v-model="eBillingPortalSelect" value-field="id" text-field="name" :options="eBillingPortalOption" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form>
                </b-col>
                <b-col class="col-md-4 mt-2">
                    <label for="client-accounting-e-billing-file-type">{{ $t('clientAccounting.e_billing_file_type') }}</label>
                    <b-form>
                        <validation-provider :name="$t('clientAccounting.e_billing_file_type')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <b-form-select :disabled="!invoiceChecked" :state="errors.length > 0 ? false : null" v-model="eBillingFileTypeSelect" value-field="id" text-field="name" :options="eBillingFileTypeOption" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col class="col-lg-12">
                    <b-form>
                        <b-form-group :label="$t('clientAccounting.special_invoice_accounting')" label-for="special_invoice_accounting">
                            <v-select :disabled="!invoiceChecked" id="specialInvoiceAccounting" v-model="specialInvoiceAccountingSelect" :options="specialInvoiceAccountingOption" class="w-100 custom-v-select agentInput" :get-option-label="$formatAgent" @input="setSpecialInvoiceAccountingId" @search="onSpecialSearch">
                            </v-select>
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12" v-if="!invoiceChecked">
                    <b-form>
                        <validation-provider :name="$t('clientAccounting.different_invoice_accounting')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <b-form-group :label="$t('clientAccounting.different_invoice_accounting')" label-for="different_invoice_accounting">
                                <v-select id="differentInvoiceAccounting" :state="errors.length > 0 ? false : null" v-model="differentInvoiceAccountingSelect" :options="differentInvoiceAccountingOption" class="w-100 custom-v-select agentInput" :get-option-label="$formatAgent" @input="setDifferentInvoiceAccountingId" @search="onDifferentSearch">
                                </v-select>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                    </b-form>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="col-lg-12">
                    <label for="invoice-discount-format">{{ $t('clientAccounting.invoice_discount_format') }}</label>
                    <b-form>
                        <validation-provider :name="$t('clientAccounting.invoice_discount_format')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <b-form-select :disabled="!invoiceChecked" :state="errors.length > 0 ? false : null" v-model="invoiceDiscountFormatSelect" value-field="id" text-field="name" :options="invoiceDiscountFormatOption" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label for="textarea-default">{{ $t('client.notes') }}</label>
                    <b-form-textarea :disabled="!invoiceChecked" id="textarea-default" :placeholder="$t('client.notes')" v-model="notes" rows="3" />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label for="textarea-default">{{ $t('clientAccounting.note_that_showed_at_every_invoice') }}</label>
                    <b-form-textarea :disabled="!invoiceChecked" id="textarea-default" :placeholder="$t('clientAccounting.note_that_showed_at_every_invoice')" v-model="noteThatShowedAtEveryInvoice" rows="3" maxlength="100" />
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getClientAccountingList: {
            type: Function
        },
        getClientList: {
            type: Function
        },
    },
    data() {
        return {
            invoiceSendTypeSelect: 0,
            invoiceSendTypeOption: [],
            taxNo: '',
            foreignCurrencySelect: 0,
            invoiceCurrencySelect: 0,
            foreignCurrencyOption: [],
            accountingInput: '',
            jurisdictionSelect: 0,
            jurisdictionOption: [],
            priceListSelect: 0,
            priceListOption: [],
            discount: 0,
            notes: '',
            accountIdNumber: null,
            agentChecked: false,
            invoiceChecked: false,
            id: 0,
            clientId: 0,
            invoiceAlertDay: 0,
            specialInvoiceAccountingSelect: 0,
            specialInvoiceAccountingOption: [],
            differentInvoiceAccountingSelect: 0,
            differentInvoiceAccountingOption: [],
            noteToBeOnInvoiceOption: [],
            noteToBeOnInvoiceSelect: 0,
            accountingCategoryOption: [],
            accountingCategorySelect: 0,
            invoiceDiscountFormatSelect: 0,
            invoiceDiscountFormatOption: [],
            invoiceSendPeriodSelect: 0,
            invoiceSendPeriodOption: [],
            invoiceSendFormatSelect: 0,
            invoiceSendFormatOption: [],
            invoiceSpecialEMailAddressToSend: '',
            eBillingFileTypeOption: [],
            eBillingFileTypeSelect: 0,
            invoiceAlertDayOption: [],
            invoiceAlertDaySelect: 0,
            eBillingPortalOption: [],
            eBillingPortalSelect: 0,
            noteThatShowedAtEveryInvoice : ''
        }
    },
    methods: {
        clear() {
            this.invoiceSendTypeSelect = 0
            this.foreignCurrencySelect = 0
            this.invoiceCurrencySelect = 0
            this.jurisdictionSelect = 0
            this.priceListSelect = 0
            this.discount = 0
            this.notes = ''
            this.accountIdNumber = null
            this.agentChecked = false
            this.invoiceChecked = false
            this.id = 0
            this.clientId = 0
            this.invoiceAlertDay = 0
            this.specialInvoiceAccountingSelect = 0
            this.differentInvoiceAccountingSelect = 0
            this.noteToBeOnInvoiceSelect = 0
            this.accountingCategorySelect = 0
            this.invoiceDiscountFormatSelect = 0
            this.invoiceSendPeriodSelect = 0
            this.invoiceSendFormatSelect = 0
            this.invoiceSpecialEMailAddressToSend = ''
            this.eBillingFileTypeSelect = 0
            this.eBillingPortalSelect = 0
            this.invoiceAlertDaySelect = 0,
            this.noteThatShowedAtEveryInvoice = ''
        },
        showInfo(id, clientId) {
            this.$refs['clientAccountingFormModal'].show()
            this.id = id
            this.clientId = clientId;
            const data = {
                id: this.id
            }
            const controller = {
                name: 'ClientAccounting'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.invoiceSendTypeOption = response.data.invoiceSendTypeList
                    this.foreignCurrencyOption = response.data.currencyList
                    this.taxNo = response.data.clientAccounting.taxNo
                    this.invoiceSendTypeSelect = response.data.clientAccounting.invoiceSendTypeId
                    this.foreignCurrencySelect = response.data.clientAccounting.currencyId
                    this.invoiceCurrencySelect = response.data.clientAccounting.invoiceCurrencyId
                    this.jurisdictionOption = response.data.jurisdictionList
                    this.jurisdictionSelect = response.data.clientAccounting.jurisdictionId
                    this.agentChecked = response.data.clientAccounting.forAgent
                    this.invoiceChecked = response.data.clientAccounting.forInvoice
                    this.priceListOption = response.data.priceListList
                    this.accountIdNumber = response.data.clientAccounting.number
                    this.priceListSelect = response.data.clientAccounting.priceListId
                    this.notes = response.data.clientAccounting.note
                    this.discount = response.data.clientAccounting.discount
                    this.noteToBeOnInvoiceOption = response.data.noteToBeOnInvoiceList
                    this.accountingCategorySelect = response.data.clientAccounting.clientAccountingCategoryId
                    this.accountingCategoryOption = response.data.clientAccountingCategoryList
                    this.invoiceDiscountFormatOption = response.data.invoiceDiscountFormatList
                    this.invoiceSendPeriodOption = response.data.invoiceSendPeriodList
                    this.invoiceSendFormatOption = response.data.invoiceSendFormatList
                    this.invoiceSpecialEMailAddressToSend = response.data.clientAccounting.invoiceSpecialEMailAddressToSend
                    this.noteThatShowedAtEveryInvoice = response.data.clientAccounting.noteThatShowedAtEveryInvoice
                    if (response.data.clientAccounting.invoiceSendFormatId > 0) {
                        this.invoiceSendFormatSelect = response.data.clientAccounting.invoiceSendFormatId
                    } else {
                        this.invoiceSendFormatSelect = 0
                    }
                    if (response.data.clientAccounting.invoiceSendPeriodId > 0) {
                        this.invoiceSendPeriodSelect = response.data.clientAccounting.invoiceSendPeriodId
                    } else {
                        this.invoiceSendPeriodSelect = 0
                    }
                    this.eBillingFileTypeOption = response.data.eBillingFileTypeList
                    if (response.data.clientAccounting.eBillingFileTypeId > 0) {
                        this.eBillingFileTypeSelect = response.data.clientAccounting.eBillingFileTypeId
                    } else {
                        this.eBillingFileTypeSelect = 0
                    }
                    this.eBillingPortalOption = response.data.eBillingPortalList
                    if (response.data.clientAccounting.eBillingPortalId > 0) {
                        this.eBillingPortalSelect = response.data.clientAccounting.eBillingPortalId
                    } else {
                        this.eBillingPortalSelect = 0
                    }
                    this.invoiceAlertDayOption = response.data.invoiceAlertDayList
                    this.invoiceAlertDayOption.splice(0, 0, this.$nullSelected())
                    this.eBillingPortalOption.splice(0, 0, this.$nullSelected())
                    this.eBillingFileTypeOption.splice(0, 0, this.$nullSelected())
                    this.invoiceSendFormatOption.splice(0, 0, this.$nullSelected())
                    this.invoiceSendPeriodOption.splice(0, 0, this.$nullSelected())
                    this.invoiceDiscountFormatOption.splice(0, 0, this.$nullSelected())
                    this.accountingCategoryOption.splice(0, 0, this.$nullSelected())
                    this.foreignCurrencyOption.splice(0, 0, this.$nullSelected())
                    this.jurisdictionOption.splice(0, 0, this.$nullSelected())
                    this.priceListOption.splice(0, 0, this.$nullSelected())
                    this.noteToBeOnInvoiceOption.splice(0, 0, this.$nullSelected('code'))
                    this.invoiceSendTypeOption.splice(0, 0, this.$nullSelected())
                    this.invoiceAlertDay = response.data.clientAccounting.invoiceAlertDay
                    if(this.invoiceAlertDay == 0){
                        this.invoiceAlertDaySelect = response.data.clientAccounting.invoiceAlertDayId
                    }
                    if (response.data.clientAccounting.noteToBeOnInvoiceId > 0) {
                        this.noteToBeOnInvoiceSelect = response.data.clientAccounting.noteToBeOnInvoiceId
                    }
                    if (response.data.clientAccounting.invoiceDiscountFormatId > 0) {
                        this.invoiceDiscountFormatSelect = response.data.clientAccounting.invoiceDiscountFormatId
                    } else {
                        this.invoiceDiscountFormatSelect = 1
                    }
                    if (response.data.clientAccounting.specialInvoiceAccountingId > 0) {
                        const clientAccountingData = {
                            clientAccountingId: response.data.clientAccounting.specialInvoiceAccountingId
                        }
                        const clientAccountingController = {
                            name: 'ClientAccounting',
                            actionName: 'GetClientAccountingByClientName'
                        }
                        const clientAccountingPayload = {
                            data: clientAccountingData,
                            controller: clientAccountingController
                        }
                        this.$store.dispatch('moduleAuth/customService', clientAccountingPayload).then((clientAccountingResponse) => {
                            this.specialInvoiceAccountingOption = clientAccountingResponse.data.clientList
                            this.specialInvoiceAccountingSelect = clientAccountingResponse.data.clientList[0]
                        })
                    } else {
                        this.specialInvoiceAccountingOption = []
                        this.specialInvoiceAccountingSelect = 0;
                    }
                    if (response.data.clientAccounting.differentInvoiceAccountingId > 0) {
                        const clientAccountingData = {
                            clientAccountingId: response.data.clientAccounting.differentInvoiceAccountingId
                        }
                        const clientAccountingController = {
                            name: 'ClientAccounting',
                            actionName: 'GetClientAccountingByClientName'
                        }
                        const clientAccountingPayload = {
                            data: clientAccountingData,
                            controller: clientAccountingController
                        }
                        this.$store.dispatch('moduleAuth/customService', clientAccountingPayload).then((clientAccountingResponse) => {
                            this.differentInvoiceAccountingOption = clientAccountingResponse.data.clientList
                            this.differentInvoiceAccountingSelect = clientAccountingResponse.data.clientList[0]
                        })
                    } else {
                        this.differentInvoiceAccountingOption = []
                        this.differentInvoiceAccountingSelect = 0;
                    }

                } else {
                    this.$bvModal.hide('clientAccountingFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            var specialInvoiceAccountingId = 0
            var differentInvoiceAccountingId = 0

            if (this.specialInvoiceAccountingSelect != null)
                specialInvoiceAccountingId = this.specialInvoiceAccountingSelect.clientAccountingId

            if (this.differentInvoiceAccountingSelect != null)
                differentInvoiceAccountingId = this.differentInvoiceAccountingSelect.clientAccountingId

            const data = {
                id: this.id,
                clientId: this.clientId,
                currencyId: this.foreignCurrencySelect,
                invoiceCurrencyId: this.invoiceCurrencySelect,
                jurisdictionId: this.jurisdictionSelect,
                forAgent: this.agentChecked,
                forInvoice: this.invoiceChecked,
                priceListId: this.priceListSelect,
                discount: this.discount,
                note: this.notes,
                invoiceAlertDay: this.invoiceAlertDay,
                specialInvoiceAccountingId: specialInvoiceAccountingId,
                differentInvoiceAccountingId: differentInvoiceAccountingId,
                noteToBeOnInvoiceId: this.noteToBeOnInvoiceSelect,
                clientAccountingCategoryId: this.accountingCategorySelect,
                taxNo: this.taxNo,
                invoiceDiscountFormatId: this.invoiceDiscountFormatSelect,
                invoiceSendTypeId: this.invoiceSendTypeSelect,
                invoiceSendPeriodId: this.invoiceSendPeriodSelect,
                invoiceSendFormatId: this.invoiceSendFormatSelect,
                eBillingPortalId: this.eBillingPortalSelect,
                eBillingFileTypeId: this.eBillingFileTypeSelect,
                invoiceSpecialEMailAddressToSend: this.invoiceSpecialEMailAddressToSend,
                noteThatShowedAtEveryInvoice : this.noteThatShowedAtEveryInvoice
            }
            const controller = {
                name: 'ClientAccounting'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('clientAccountingFormModal')
                            this.getClientAccountingList()
                            if (this.getClientList != null)
                                this.getClientList()
                            this.$SaveAlert()
                        } else {
                            if (response.data.resultMessage == "AddClientAddressFirst") {
                                this.$AddClientAddressFirst()
                            } else {
                                this.$WarningAlert(response.data.resultMessage)
                            }
                        }
                    })
                }
            })
        },
        setSpecialInvoiceAccountingId(event) {
            this.specialInvoiceAccountingSelect = event
        },
        setDifferentInvoiceAccountingId(event) {
            this.Select = event
        },
        onSpecialSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.searchSpecialInvoiceAccounting(loading, search, this);
            }
        },
        onDifferentSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.searchDifferentInvoiceAccounting(loading, search, this);
            }
        },
        searchSpecialInvoiceAccounting(loading, search, vm) {
            if (search.length > 2) {
                const data = {
                    clientAccountingId: 0,
                    clientName: search,
                    forAgentOrInvoice: 2,
                }
                const controller = {
                    name: 'ClientAccounting',
                    actionName: 'GetClientAccountingByClientName'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.specialInvoiceAccountingOption = response.data.clientList
                    loading(false)
                })
            }
        },
        searchDifferentInvoiceAccounting(loading, search, vm) {
            if (search.length > 2) {
                const data = {
                    clientAccountingId: 0,
                    clientName: search,
                    forAgentOrInvoice: 2,
                }
                const controller = {
                    name: 'ClientAccounting',
                    actionName: 'GetClientAccountingByClientName'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.differentInvoiceAccountingOption = response.data.clientList
                    loading(false)
                })
            }
        },
        onInvoiceAlertDaySelectChange() {
            //STOCK-2692
            if (this.invoiceAlertDaySelect != 4 && this.invoiceAlertDaySelect != 0) {
                this.invoiceAlertDay = this.invoiceAlertDayOption.find(d => d.id == this.invoiceAlertDaySelect).alertDay
            }
            else if(this.invoiceAlertDaySelect == 0) {
                this.invoiceAlertDay = 0
            }
            //
        },
        onInvoiceCheckedChange(){

        }
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

[dir] .vs__selected-options {
    padding: 0 2px;
    font-size: 0.9em;
}

.agentInput {
    max-width: 87em !important;
    width: 86em !important;
}

.custom-v-select .vs__selected,
.custom-v-select .vs__dropdown-option {
    white-space: pre-wrap !important;
}
</style>
